import { email } from 'react-admin';
import { checkPassword } from '../users/utils';

export const validateForm = (mode) =>
    values => {
        const errors = {};

        if (!values.email) {
            errors.email = 'ra.validation.required';
        } else {
            const error = email()(values.email);
            if (error) {
                errors.email = error;
            }
        }

        if (!values.password) {
            errors.password = 'ra.validation.required';
        }

        if (mode == "signup") {
            if (values.password !== values.confirm_password) {
                errors.password = 'Passwords are different.';
            } else {
                const { pass, error } = checkPassword(values.password)
                if (!pass) {
                    errors.password = error;
                }
            }
        }
        
        return errors;
    };